import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { CSVLink } from "react-csv";
import moment from "moment";
import mail from "../../assets/images/icon/mail.svg";
import dowanload_csv from "../../assets/images/icon/downloadcsv.svg";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import {
  GetQuestionBehaviourList,
  DeleteQuestionbehaviourRecords,
} from "../../services/QuestionsService";
import { toast } from "react-toastify";
import { Container, Row, Col } from "react-bootstrap";
import {
  checkPermissionStatus,
  getCompanyTimezoneDateTime,
} from "helpers/utils";

const QuestionBehaviourList = () => {
  const [questionBehaviourList, setQuestionBehaviourList] = useState([]);
  const [query, setQuery] = useState("");
  const [csvData, setCSVData] = useState([]);
  const [error, setError] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const companyId = localStorage.getItem("subdomainId");

  useEffect(() => {
    GetQuestionBehaviourList()
      .then(res => {
        if (res?.data?.status) {
          setQuestionBehaviourList(res?.data?.data);
        }
      })
      .catch(err => {
        toast.error("No data Available");
      });
    document.title = "NeuroTal - Question Behaviour List";
  }, []);

  const handleDeleteRecords = id => {
    DeleteQuestionbehaviourRecords(id)
      .then(res => {
        if (res?.status === 200) {
          console.log(res);
          let messages = toast.success(res?.data?.message);
          window.location.href = "/question-behaviour-list";
        } else {
          let messages = toast.success(res?.data?.message);
          console.error("Delete record failed:", res?.data?.message);
        }
      })
      .catch(error => {
        console.error("Error deleting record:", error);
      });
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing rows {from} to {to} of {size}
    </span>
  );

  //Handle CSV

  const handleCSVDownload = async e => {
    e.preventDefault();
    let data = questionBehaviourList?.filter(renderCheck);
    setCSVData(data);
    setTimeout(() => {
      let element = document.getElementById("downloadCSV");
      element.click();
    }, 1000);
  };

  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  let columns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
    },
    {
      dataField: "ques_behav",
      text: "Question Behaviour",
    },
    {
      dataField: "Company.company_name",
      text: "Company Name",
      hidden: companyId, // Hide the column if companyId exist
    },
    {
      dataField: "VacancyType.title",
      text: "Position Level",
    },
    {
      dataField: "good",
      text: "Good",
      classes: "white-hidden",
    },
    {
      dataField: "average",
      text: "Average",
      classes: "white-hidden",
    },
    {
      dataField: "poor",
      text: "Poor",
      classes: "white-hidden",
    },
    {
      dataField: "createdAt",
      text: "Created At",
      formatter: cell => {
        return moment(getCompanyTimezoneDateTime(cell))?.format("DD MMM YYYY");
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cellContent, row) => (
        <>{row?.status == "1" ? "Active" : "In Active"}</>
      ),
    },
  ];

  if (checkPermissionStatus("question-behaviour-list", "view")) {
    columns.push({
      dataField: "",
      text: "Actions",
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex gap-1 blue-icon-gap action-application">
            <Link
              className="text-success blue-icon action-one"
              to={`/edit-question-behaviour/${row.id}`}
              title="Edit Question Behaviour"
            >
              <i
                className="mdi mdi-pencil-outline font-size-18"
                id="logintooltip"
                style={{ color: "black" }}
              ></i>
              <span>Edit</span>
            </Link>
            <div
              onClick={() => handleDeleteRecords(row.id)}
              className="text-success blue-icon action-one"
              style={{ cursor: "pointer" }}
              to="#"
              title="Delete Record"
            >
              <i
                className="mdi mdi-trash-can font-size-18"
                style={{ color: "black" }}
              ></i>
              <span>Delete</span>
            </div>
          </div>
        );
      },
    });
  }

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  const renderCheck = item => {
    const searchableText = (
      item?.vacancy_id +
      item?.ques_behav +
      moment(getCompanyTimezoneDateTime(item?.createdAt)).format(
        "DD MMM YYYY"
      ) +
      (item?.status === "1" ? "Active" : "In Active")
    ).toLowerCase();
    return searchableText.includes(query.toLowerCase());
  };

  if (!checkPermissionStatus("question-behaviour-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">Access Denied.</h4>
      </div>
    );
  }

  return (
    <>
      <div className="tab-content" id="pills-tabContent">
        <Row className="mb-3 align-items-center border-bottom py-2">
          <Col sm="8">
            <h5 className="text-uppercase heading-one">
              Question Behaviour List
            </h5>
          </Col>
        </Row>
        <div
          className="tab-pane fade show active"
          id="pills-home"
          role="tabpanel"
          // aria-labelledby="pills-home-tab"
        >
          <div className="tabel-application table-responsive white-space-row pb-3">
            <div className="table-data-search">
              <div className="total-record">
                <h5>
                  Total Records:{" "}
                  <span>{questionBehaviourList?.length || 0}</span>
                </h5>
              </div>
              <div className="total-serachbar">
                <div className="serach-bar-top">
                  <form class="form-inline">
                    <input
                      class="form-control mr-sm-2"
                      type="search"
                      placeholder="Search by question behaviour,"
                      aria-label="Search"
                      onChange={e => setQuery(e.target.value)}
                    />
                    <span>
                      <img src={serach_icon} alt="search" />
                    </span>
                  </form>
                </div>

                {checkPermissionStatus(
                  "question-behaviour-list",
                  "downloadcsv"
                ) && (
                  <div className="take-text">
                    <CSVLink
                      data={csvData}
                      headers={[
                        {
                          key: "id",
                          label: "S No.",
                        },
                        {
                          key: "ques_behav",
                          label: "Question Behviour",
                        },
                        {
                          key: "VacancyType.title",
                          label: "Position Level",
                        },

                        {
                          key: "good",
                          label: "Good",
                        },
                        {
                          key: "avarage",
                          label: "Avarage",
                        },
                        {
                          key: "poor",
                          label: "Poor",
                        },
                        {
                          key: "status",
                          label: "Status",
                        },
                        {
                          key: "createdAt",
                          label: "Created Date",
                        },
                        {
                          key: !companyId ? "Company.company_name" : "", // Conditionally include "Company Name" if companyId does't exists
                          label: !companyId ? "Company Name" : "",
                        },
                      ]}
                      filename={`QuestionBehaviourList.csv`}
                      id="downloadCSV"
                    >
                      <Button
                        color="info"
                        onClick={e => handleCSVDownload(e)}
                        outline
                      >
                        <img src={dowanload_csv} alt="Download" /> Download CSV
                      </Button>
                    </CSVLink>
                  </div>
                )}

                {checkPermissionStatus("question-behaviour-list", "create") && (
                  <div className="take-text filter">
                    <Link
                      to="/create-question-behaviour"
                      className="btn btn-primary"
                    >
                      + Create
                    </Link>
                  </div>
                )}
              </div>
            </div>
            {successMessage && (
              <div class="alert alert-success" role="alert">
                {successMessage}
              </div>
            )}
            {errorMessage && (
              <div class="alert alert-danger" role="alert">
                {errorMessage}
              </div>
            )}
            <BootstrapTable
              keyField="id"
              data={questionBehaviourList?.filter(renderCheck)}
              columns={columns}
              pagination={paginationFactory(options)}
              rowClasses={rowClasses}
              hover
              responsive
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionBehaviourList;
